import { render, staticRenderFns } from "./TaskRibbon.vue?vue&type=template&id=6da693fb"
import script from "./TaskRibbon.vue?vue&type=script&lang=js"
export * from "./TaskRibbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports